import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../services/user.service';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  home: boolean = false;
  formObj:any = {
    otc_desk: {
      es: "",
      en: "",
    },
    eotc_desk: {
      es: "",
      en: "",
    },
    liquidity: {
      es: "",
      en: "",
    },
    api: {
      es: "",
      en: "",
    },
    fully_compliant: {
      es: "",
      en: "",
    },
    white_label_solutions: {
      es: "",
      en: "",
    },
    aboutus: {
      es: "",
      en: "",
    },
    highlights: {
      es: "",
      en: "",
    },
    block_trading: {
      es: "",
      en: "",
    },
    crypto_coins: {
      es: "",
      en: "",
    },
    coin_marketing: {
      es: "",
      en: "",
    },
    why_choose: {
      es: "",
      en: "",
    },
    getin_touch: {
      es: "",
      en: "",
    },
  };
  homeList = [];
  errorObj;

  constructor(private userService : UserService, private notif : NotificationsService, private homeService : HomeService) { 
    this.loadTableData()
  }
  loadTableData(){
    this.homeService.geAllHomes().subscribe(res => {
      this.homeList = res.data;
    })
  }
  clearError(field) {
    switch (field) {
      case "name":
        this.errorObj.name = "";
        break;
    }
  }
  resetForm() {
    for (const key in this.formObj) {
      this.formObj[key] = "";
    }
    if (this.formObj._id) delete this.formObj._id;
    this.loadTableData();
  }
  homeForm(obj: any, editableObj = null) {
    if (obj == "show") {
      this.home = true;
    } else if (obj == "hide") {
      this.home = false;
    }
    if (editableObj) {
      this.formObj = editableObj;
    }
  }
  addHomes(home) {
    this.userService.csrf().subscribe((success) => {
      this.formObj["_csrf"] = success._csrf;     
      this.homeService.saveHomes(this.formObj).subscribe(
        (response) => {
          this.notif.success("Success", response.data.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
          if(!this.formObj._id) {
            home.resetForm({});
            this.resetForm();
          }          
        },
        (err) => {
          this.notif.error("Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    });
  }
  deleteHome(homeData) {
    this.userService.csrf().subscribe((success) => {
      homeData["_csrf"] = success._csrf;
      this.homeService.deleteHome(homeData).subscribe((response: any) => {
        this.notif.success("Deleted successfully", response.data.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.resetForm();
      });
    });
  }
  ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts